/**
 * @desc 保存商品信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.MallGoodsWithImg): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/mall/goods/save',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
